import { client } from '@/common-utils/libraries/axios/axios';
import DOCUMENTATION from '../apiUrls';
import DOCUMENTATION_FIELDS from '../../fields/DocumentationFields';

const mapResponseData = (responseData) => {
    const data = {
        [DOCUMENTATION_FIELDS.URL.key]: responseData[DOCUMENTATION_FIELDS.URL.key]
    };

    return data;
};

const queryGetApiDocumentation = (enabled = true) => {
    return {
        queryKey: [DOCUMENTATION.API.queryKey],
        queryFn: async () => {
            const response = await client.get(DOCUMENTATION.API.url);
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetApiDocumentation;